(() => {
  if (window.OWShippingProcessModalInitialized) return;

  window.OWShippingProcessModalInitialized = true;

  const loadModalImage = (modal) => {
    const image = modal.querySelector('[data-shipping-process-image]');

    if (!(image instanceof HTMLImageElement) || image.src) return;

    const src = image.dataset.src;
    if (src) image.src = src;
  };

  const openModal = (button) => {
    const root = button.closest('[data-shipping-process-root]');
    const modal = root?.querySelector('[data-shipping-process-modal]');

    if (!(modal instanceof HTMLDialogElement)) return;

    loadModalImage(modal);

    if (typeof modal.showModal === 'function') {
      modal.showModal();
    } else {
      modal.setAttribute('open', '');
    }
  };

  const closeModal = (modal) => {
    if (!(modal instanceof HTMLDialogElement)) return;

    if (typeof modal.close === 'function') {
      modal.close();
    } else {
      modal.removeAttribute('open');
    }
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const openButton = target?.closest('[data-shipping-process-open]');

    if (openButton instanceof HTMLButtonElement) {
      openModal(openButton);
      return;
    }

    const closeButton = target?.closest('[data-shipping-process-close]');
    if (closeButton instanceof HTMLButtonElement) {
      closeModal(closeButton.closest('[data-shipping-process-modal]'));
      return;
    }

    if (!(event.target instanceof HTMLDialogElement) || !event.target.matches('[data-shipping-process-modal]')) {
      return;
    }

    const modal = event.target;
    const rect = modal.getBoundingClientRect();
    const clickedInside =
      rect.top <= event.clientY &&
      event.clientY <= rect.top + rect.height &&
      rect.left <= event.clientX &&
      event.clientX <= rect.left + rect.width;

    if (!clickedInside) closeModal(modal);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    document.querySelectorAll('[data-shipping-process-modal][open]').forEach((modal) => closeModal(modal));
  });
})();
